var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Ope-Dash-Operacional"},[_c('PageTitle',{attrs:{"icon":"fa fa-bar-chart","main":"Dashboard Operacional","sub":"Indicadores"}}),_c('div',{staticClass:"Ope-Dash-Operacional"},[_vm._v("\nDashboard\n\n\n\n        ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }